import { PeriodAttendanceForAcademicYear } from "@godalming/api-types";
import { portalApi } from "@services/api/portalApi";

export async function getStudentYearPeriodAttendance(studentNo: string) {
    try {
        const response = await portalApi.get<PeriodAttendanceForAcademicYear[]>(`/students/${studentNo}/year-period-attendance`);
        return response.data;
    } catch (error) {
        console.error("Error fetching student year period attendance:", error);
        throw error;
    }
}
